import ApiBase from 'Services/Api/ApiBase';

class Notifications extends ApiBase {
    route = '/admin/comms/notifications';
}

export default new Notifications();
